// extracted by mini-css-extract-plugin
module.exports = {"boxFeedback":"Feedback_boxFeedback__KubJt"};